import axios from "axios";
import config from "config";

export async function sendEmailToSupport(name: string, email: string, question: string, urgency: string) {
  return await axios.post(config.SEND_EMAIL_LAMBDA, {
    name: name,
    email: email,
    urgency: urgency,
    question: question,
    vertical: config.VERTICAL,
  });
}
